import { render, staticRenderFns } from "./ReservoirRuler.vue?vue&type=template&id=1d85371c&scoped=true"
import script from "./ReservoirRuler.vue?vue&type=script&lang=js"
export * from "./ReservoirRuler.vue?vue&type=script&lang=js"
import style0 from "./ReservoirRuler.vue?vue&type=style&index=0&id=1d85371c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d85371c",
  null
  
)

export default component.exports